import styled from 'styled-components'

import {
    BoardChart,
    BoardContainer,
    BoardStatistics,
    BoardStats,
} from '../Board/Board.styled'

export const BoardAutoContainer = styled(BoardContainer)`
    background-color: rgb(248, 248, 250);
    grid-template-areas:
        'funded statics iframe'
        'chart chart iframe'
        'footer footer footer';
    grid-template-rows: 0.43fr 1fr 0.2fr;
    grid-template-columns: 0.85fr 0.5fr 1fr;
    column-gap: 5px;
    row-gap: 5px;
    border: none;
    &:hover {
        box-shadow: none;
    }
    footer {
        grid-area: footer;
    }
`

const LocalBaseBoardStatistics = styled(BoardStatistics)`
    min-height: 0;
    min-width: 0;
    border-bottom: var(--dashboard-default-border);
    border-top: none;
    border-right: None;
    border-left: None;
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
`

export const BoardFundedStatistics = styled(LocalBaseBoardStatistics)`
    grid-area: funded;
    border-top-left-radius: 5px 5px;
    padding: 5px 0 5px 0;
    background-color: white;
`

export const BoardAppStatistics = styled(LocalBaseBoardStatistics)`
    grid-area: statics;
    padding: 5px 10px 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    background-color: white;
`
export const BoardIFrame = styled(BoardStatistics)`
    grid-area: iframe;
    iframe {
        width: 100%;
        height: 100%;
    }
    height: 100%;
    width: 100%;
    border-left: var(--dashboard-default-border);
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
`

export const BoardFundedStats = styled(BoardStats)`
    margin: 0;
    position: relative;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
`

export const BoardAppStats = styled(BoardStats)`
    grid-template-columns: 1fr;
    margin: 0;
    position: relative;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
`

export const BoardBaseStat = styled.div`
    padding: 0 15px 15px 10px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    strong {
        font-size: 28px;
        font-weight: bold;
        display: block;
    }
    span {
        font-size: 11px;
        padding: 0 0 0 10px;
    }
    border-left: var(--dashboard-default-border);
`

export const BoardFundedStat = styled(BoardBaseStat)`
    &:nth-child(-n + 2) {
        color: var(--dashboard-main-color);
        margin-right: 0;
        padding-bottom: 1em;
        strong {
            font-size: 3em;
            line-height: 50px;
        }
        span {
            font-size: 1.2em;
        }
    }
    &:first-child {
        border-left: none;
    }
    &:last-child {
        color: rgb(124, 195, 148);
    }
    flex-direction: column;
`

export const BoardAppStat = styled(BoardBaseStat)`
    strong {
        font-size: 25px;
    }
    span {
        font-size: 15px;
        padding-top: 5px;
    }
    border: none;
    &:first-child {
        color: gray;
    }
    justify-content: left;
    padding-bottom: 11px;
`

export const BoardAutoChart = styled(BoardChart)`
    grid-area: chart;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    background-color: white;
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
`
